import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHeaders,
    HttpClient
  } from '@angular/common/http';
  import { Observable, throwError } from 'rxjs';
  import { retry, catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AppAuthService } from '../auth/auth.service';
import { UserSessionService } from '../auth/user-session.service';
import { ApiError, isInvalidGrant, resolveHttpErrorMessage } from './http-error.util';

  @Injectable({
    providedIn: 'root',
})  
  export class HttpErrorInterceptor implements HttpInterceptor { 
    private endPoint = '/ValidateUser/AuthorizeUser';

    constructor(
      public toastr: ToastrService,
      private appAuthService: AppAuthService,
      private http: HttpClient,
      private router: Router,
      private userData: UserSessionService) { }

      intercept(
        request: HttpRequest<any>,
        next: HttpHandler
      ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
          map((event: HttpEvent<any>) => {
            // Check if the event is an HttpResponse
            if (event instanceof HttpResponse) {
              if (event.status === 200) {
                  if(event.body?.message === "No records found"){
                      this.toastr.success("No records found", '');  
                  }
                  else if(event.body?.message === "User don't have rights to access this page"){
                      this.toastr.error("User don't have rights to access this page", '');  
                     this.router.navigateByUrl('/app/access-denied/access-denied');
                  }
              }
          }                  
          return event
        }),
        catchError((error: any) => {
          // Already reported by an inner interceptor - don't toast it twice.
          if (error instanceof ApiError) {
            return throwError(() => error);
          }
          const errorMessage = this.getServerErrorMessage(error);
          this.toastr.error(errorMessage, '');
          return throwError(() => new ApiError(errorMessage, error?.status ?? 0, error));
        })
      );
    }

    /** Prefer the message the backend actually sent over Angular's generic one. */
    private getServerErrorMessage(error: HttpErrorResponse): string {
      if (isInvalidGrant(error)) {
        this.appAuthService.logoutUser({ noReload: true });
        return error.error?.error_description || 'Session expired. Please log in again.';
      }
      return resolveHttpErrorMessage(error);
    }
  }
